import { useEffect, useState } from "react"

import { SolicitudFirmaModal, TableCustom } from "../../../components/common"
import { useLista, useManagedContext } from "../../../components/hooks"
import { APIS } from "../../../config/apis"
import { ALERT_TYPE, FIRMA_TYPE, REQUEST_METHOD, ShowToastMessage } from '@laramie/ui';
import { getDateToString } from "../../../utils/convert"
import { standardRequest } from "../../../utils/requests"
import { MESSAGE_MODALS } from "../../../context/custom/MessageModalContext"
import TituloEjecutivoTextosModal from "../../../components/controls/TituloEjecutivoTextosModal"


const CertificadoApremioTituloGrid = ({ idCertificadoApremio, idFirmaDigitalTituloEjecutivo, pendingChange, refetch }) => {
    const { setIsLoading } = useManagedContext()

    const [firmas, setFirmas] = useState([])
    const [modalItem, setModalItem] = useState(null)
    const [showTextosModal, setShowTextosModal] = useState(false)

    const [_getListLista, getRowLista] = useLista({
        listas: ["EstadoFirma"],
        onLoaded: (listas, isSuccess, error) => {
            if (!isSuccess) ShowToastMessage(ALERT_TYPE.ALERT_ERROR, error)
        },
        memo: {
          key: "CertificadoApremioTituloGridEstadoFirma",
          timeout: 0
        },
    });

    useEffect(() => {
        if (!idFirmaDigitalTituloEjecutivo) return

        setIsLoading(true)

        standardRequest(REQUEST_METHOD.GET, `${APIS.URLS.FIRMA_DIGITAL}/${idFirmaDigitalTituloEjecutivo}`)
        .then(data => setFirmas([data]))
        .catch(() => {})
        .finally(() => setIsLoading(false))
    }, [idFirmaDigitalTituloEjecutivo])

    const signAction = (textos) => {
        setShowTextosModal(false)
        setIsLoading(true)

        standardRequest(
            REQUEST_METHOD.PUT,
            `${APIS.URLS.FIRMA_DIGITAL}/tipo-firma/${FIRMA_TYPE.TITULO_EJECUTIVO}`,
            { idEntidad: idCertificadoApremio, ...textos }
        )
        .then(data => {
            ShowToastMessage(ALERT_TYPE.ALERT_SUCCESS, "Solicitud de firma digital enviada correctamente")
            setTimeout(refetch, 500)
        })
        .catch(error => setIsLoading(false))
    }

    const avmr = {
        onAdd: firmas.some(x => x.idEstadoFirma !== 652) ? undefined : () => {
            if (pendingChange) {
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, "Debe guardar los cambios antes de crear una solicitud de firma digital")
                return
            }

            setShowTextosModal(true)
        },
        onView: (item) => {
            setModalItem(item)
        },
        onDownload: async ({ id }) => {
            setIsLoading(true)
            standardRequest(REQUEST_METHOD.GET, `${APIS.URLS.FIRMA_DIGITAL}/${id}/signed-file`)
            .then(({ file64 }) => {
                const a = document.createElement("a")
                a.href = "data:application/pdf;base64," + file64
                a.download = "documento.pdf"
                a.click()
            })
            .catch(() => {})
            .finally(() => setIsLoading(false))
        }
    }

    return <>
        {!!modalItem && (
            <SolicitudFirmaModal data={modalItem} onDismiss={() => setModalItem(null)} />
        )}

        {showTextosModal && (
            <TituloEjecutivoTextosModal onConfirm={signAction} onDismiss={() => setShowTextosModal(false)} />
        )}

        <TableCustom
            className="TableCustomBase"
            showFilterGlobal={false}
            showDownloadCSV={false}
            data={firmas}
            avmr={avmr}
            columns={[{
                Header: 'Fecha de solicitud',
                Cell: ({ value }) => getDateToString(value),
                accessor: 'fechaSolicitud',
                width: '20%',
            },{
                Header: 'Estado',
                Cell: ({ value }) => getRowLista("EstadoFirma", value)?.nombre ?? '',
                accessor: 'idEstadoFirma',
                width: '20%',
            },{
                Header: 'Observación',
                accessor: 'observacion',
            },]}
        />
    </>
}

export default CertificadoApremioTituloGrid
